import React, { useEffect, useState } from 'react';

import styles from './DiscountTag.module.scss';
import clsx from 'clsx';
import { DiscountTagProps } from './DiscountTagTypes';



const DiscountTag: React.FC<DiscountTagProps> = ({
  fullPrice = null,
  discountPrice = null,
  customStyles = '',
  placement = ''
}) => {
  const [showDiscountTag, setShowDiscountTag] = useState(false);

  useEffect(() => {
    if (typeof localStorage === 'undefined') {
      return;
    }

    try {
      const showDiscountTagObject = JSON.parse(
        localStorage.getItem('isShowDiscountTags'),
      );
      setShowDiscountTag(showDiscountTagObject?.state);
    } catch (error) {
      console.error("Error parsing isShowDiscountTags local storage item", error);
    }
  }, []);

  if (!showDiscountTag || !fullPrice || !discountPrice) return null;

  // Calculate the discount percent
  const discountPercent = 100 - Math.round((discountPrice * 100) / fullPrice);
  return discountPercent && discountPercent > 0 ? (
    <div className={styles.discountTagWrapper}>
      <span
        className={clsx(styles.discountTag, {
          [customStyles]: !!customStyles,
          [styles[`placement_${placement}`]]: placement,
        })}
      >
        You save {discountPercent}%
      </span>
    </div>
  ) : null;
};

export default DiscountTag;
